export default {
  navigationBarTitleText: '更火隐私政策'
}
